import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './DashboardStudent/Layout/Layout'
import Home from './DashboardStudent/Home'
import Notifications from './DashboardStudent/Notifications'
import Feedback from './DashboardStudent/Feedback'
import SignupOtp from './AccountStudent/SignupOtp'
import Signup from './AccountStudent/Signup'
import Successfull from './AccountStudent/Successfull'
import Login from './AccountStudent/Login'
import LoginOtp from './AccountStudent/LoginOtp'
import Subject from './InquiryStudent/Subject'
import Location from './InquiryStudent/Location'
import Education from './InquiryStudent/Education'
import SubSubjects from './InquiryStudent/SubSubjects'
import Fee from './InquiryStudent/Fee'
import Classes from './InquiryStudent/Classes'
import Days from './InquiryStudent/Days'
import Start from './InquiryStudent/Start'
import Online from './InquiryStudent/Online'
import Gender from './InquiryStudent/Gender'
import HomeClass from './DashboardStudent/HomeClass'
import AccountProfile from './DashboardStudent/AccountProfile'
import AccountSettings from './DashboardStudent/AccountSettings'
import DashboardHome from './DashboardTeacher/DashboardHome/DashboardHomeEnquiry'
import DashboardHomeEnquiryClick from './DashboardTeacher/DashboardHome/DashboardHomeEnquiryClick'
import ProfileInformation from './DashboardTeacher/DashboardProfile/ProfileInformation/ProfileInformation'
import ProfileEdit from './DashboardTeacher/DashboardProfile/ProfileInformation/ProfileEdit'
import ProfileTagline from './DashboardTeacher/DashboardProfile/ProfileInformation/ProfileTagline'
import PhoneNumber from './DashboardTeacher/DashboardProfile/ProfileInformation/PhoneNumber'
import Address from './DashboardTeacher/DashboardProfile/ProfileInformation/Address'
import QualificationExp from './DashboardTeacher/DashboardProfile/ProfileInformation/Qualification&Exp'
import ProfileEducation from './DashboardTeacher/DashboardProfile/ProfileInformation/ProfileEducation'
import Language from './DashboardTeacher/DashboardProfile/ProfileInformation/Language'
import Summary from './DashboardTeacher/DashboardProfile/ProfileInformation/Summary'
import SchoolLocation from './DashboardTeacher/DashboardProfile/ProfileInformation/SchoolLocation'
import Tutoring from './DashboardTeacher/DashboardProfile/ProfileInformation/Tutoring'
import ClassConducted from './DashboardTeacher/DashboardProfile/ClassConducted/ClassConducted'
import PricingClass from './DashboardTeacher/DashboardProfile/Pricing/PricingClass'
import ClassCourse from './DashboardTeacher/DashboardProfile/Pricing/ClassCourse'
import Reviews from './DashboardTeacher/DashboardProfile/Review/Reviews'
import TutorProfile from './DashboardTeacher/DashboardProfile/Profile/TutorProfile'
import CloseAccount from './DashboardTeacher/Account/CloseAccount'
import SubscriptionPlan from './DashboardTeacher/Subscription/SubscriptionPlan'
import SubscriptionHistory from './DashboardTeacher/Subscription/SubscriptionHistory'
import CreditHistory from './DashboardTeacher/Credit/CreditHistory'
import TeacherReviews from './DashboardStudent/TeacherReviews'
import EnquiryDetails from './DashboardStudent/EnquiryDetails'
import CreateReview from './DashboardStudent/CreateReview'
import HelpAndSupport from './DashboardStudent/HelpAndSupport'
import SignupTeacher from './AccountTeacher/SignupTeacher'
import VerifyOtp from './AccountTeacher/VerifyOtp'
import FormTeacher from './AccountTeacher/FormTeacher'
import LoginTeacher from './AccountTeacher/LoginTeacher'
import NotificationTeacher from './DashboardTeacher/NotificationTeacher'
import TermsAndConditions from './TermsAndPrivacy/TermsAndConditions'
import RefundPolicy from './TermsAndPrivacy/RefundPolicy'
import PrivacyPolicyMobile from './TermsAndPrivacy/PrivacyPolicyMobile'
import RefundPolicyMobile from './TermsAndPrivacy/RefundPolicyMobile'
import TermsAndConditionsMobile from './TermsAndPrivacy/TermsAndConditionsMobile'
import UpdateNumberOtp from './AccountTeacher/UpdateNumberOtp'
import AddClass from './DashboardTeacher/DashboardProfile/ClassConducted/AddClass'
import AccountDeleteStudent from './AccountStudent/AccountDeleteStudent'
import AccountDeleteTeacher from './AccountTeacher/AccountDeleteTeacher'
import Landing from './LandingPage/Landing'
import AdminLogin from './AccountAdmin/AdminLogin'
import AdminDashboard from './AccountAdmin/AdminDashboard'
import AdminCreatePost from './AccountAdmin/AdminCreatePost'
import Protected from './Protected'
import StudentList from './AccountAdmin/StudentList'
import TeacherList from './AccountAdmin/TeacherList'
import HelpSupport from './DashboardTeacher/Account/HelpSupport'
import ManageCredit from './AccountAdmin/ManageCredit'
import ManageFeedback from './AccountAdmin/ManageFeedback'
import ManageEnquiry from './AccountAdmin/ManageEnquiry'
import NotFound from './LandingPage/NotFound'
import { Sitemap } from '../sitemap/Sitemap'
import { SitemapSlug } from '../sitemap/SitemapSlug'
import '../../components/pages/useAnalytics'
import Institute from '../sitemap/Institute'
import ContactUs from '../Navigation/ContactUs'
import ForTeacher from '../Navigation/ForTeacher'
import ForStudent from '../Navigation/ForStudent'
import NavBar from '../Navigation/NavBar'
import StudyMaterial from '../Navigation/StudyMaterial'
import TeacherJobs from '../sitemap/TeacherJobs'
import BoardAndClasses from '../Navigation/BoardAndCourses'
import SubjectsStudyMaterial from '../Navigation/SubjectsStudyMaterial'
import ClassesStudymaterial from '../Navigation/ClassesStudymaterial'
import Notes from '../Navigation/Notes'
import Chapter from '../Navigation/Chapter'
import KathmanduPage from './KathmanduPage'
import OnlineCoaching from './OnlineCoaching'
import Blogs from './Blogs/Blogs'
import BlogNextPage from './Blogs/BlogNextPage'
import Allpost from './Blogs/Allpost'
import AddPost from './Blogs/AddPost'
import TeacherSec from './TeacherSec'
import AddTeacher from './ExpertFaculty/AddTeacher'
import AllTeachers from './ExpertFaculty/AllTeachers'
import MathematicstutorsJaipur from './HomeTutorsCities/Jaipur/MathematicstutorsJaipur'
import CBSEtutorsJaipur from './HomeTutorsCities/Jaipur/CBSEtutorsJaipur'
import IIT_JEEHometutorjaipur from './HomeTutorsCities/Jaipur/IIT_JEEHometutorjaipur'
import HometutorsJaipur from './HomeTutorsCities/Jaipur/HometutorsJaipur'
import HometutorsDelhi from './HomeTutorsCities/Delhi/HometutorsDelhi'
import IIT_JEEHometutorDelhi from './HomeTutorsCities/Delhi/IIT_JEEHometutorDelhi'
import CBSEtutorsDelhi from './HomeTutorsCities/Delhi/CBSEtutorsDelhi'
import MathematicstutorsDelhi from './HomeTutorsCities/Delhi/MathematicstutorsDelhi'
import HometutorsGurugram from './HomeTutorsCities/Gurugram/HometutorsGurugram'
import IIT_JEEHometutorGurugram from './HomeTutorsCities/Gurugram/IIT_JEEHometutorGurugram'
import CBSEtutorsGurugram from './HomeTutorsCities/Gurugram/CBSEtutorsGurugram'
import MathematicstutorsGurugram from './HomeTutorsCities/Gurugram/MathematicstutorsGurugram'
import HometuitionsBangalore from './HomeTutorsCities/Bangalore/HometuitionsBangalore'
import IITjeeTutionsBangalore from './HomeTutorsCities/Bangalore/IITjeeTutionsBangalore'
import CBSEHomeTutorsBangalore from './HomeTutorsCities/Bangalore/CBSEHomeTutorsBangalore'
import MathematicsTutorsBangalore from './HomeTutorsCities/Bangalore/MathematicsTutorsBangalore'
import HomeTuitionMumbai from './HomeTutorsCities/Mumbai/HomeTuitionMumbai'
import IitJeetuitionsMumbai from './HomeTutorsCities/Mumbai/IitJeetuitionsMumbai'
import CbseHomeTutorsMumbai from './HomeTutorsCities/Mumbai/CbseHomeTutorsMumbai'
import MathematicsTuitionMumbai from './HomeTutorsCities/Mumbai/MathematicsTuitionMumbai'
import HometuitionAhmedabad from './HomeTutorsCities/Ahmedabad/HometuitionAhmedabad'
import IITJEETuitionAhmedabad from './HomeTutorsCities/Ahmedabad/IITJEETuitionAhmedabad'
import CBSETuitioninAhmedabad from './HomeTutorsCities/Ahmedabad/CBSETuitioninAhmedabad'
import MathematicsTuitionAhmedabad from './HomeTutorsCities/Ahmedabad/MathematicsTuitionAhmedabad'
import HometuitioninPune from './HomeTutorsCities/Pune/HometuitioninPune'
import IITJEEtutionsPune from './HomeTutorsCities/Pune/IITJEEtutionsPune'
import CBSEHomeTutorsPune from './HomeTutorsCities/Pune/CBSEHomeTutorsPune'
import MathematicsTutorsPune from './HomeTutorsCities/Pune/MathematicsTutorsPune'
import MathematicsTutorsHyderabad from './HomeTutorsCities/Hyderabad/MathematicsTutorsHyderabad'
import CBSEHomeTutorsHyderabad from './HomeTutorsCities/Hyderabad/CBSEHomeTutorsHyderabad'
import IITJEEtutionsHyderabad from './HomeTutorsCities/Hyderabad/IITJEEtutionsHyderabad'
import HometuitionsHyderabad from './HomeTutorsCities/Hyderabad/HometuitionsHyderabad'
import AboutUs from './AboutUs'
import HomeTuitionNagpur from './HomeTutorsCities/Nagpur/HomeTuitionNagpur'
import IITJEEHomeTuitionNagpur from './HomeTutorsCities/Nagpur/IITJEEHomeTuitionNagpur'
import CBSEHomeTuitioninNagpur from './HomeTutorsCities/Nagpur/CBSEHomeTuitioninNagpur'
import MathematicsHomeTuitionNagpur from './HomeTutorsCities/Nagpur/MathematicsHomeTuitionNagpur'
import HomeTuitionKanpur from './HomeTutorsCities/Kanpur/HomeTuitionKanpur'
import IITJEEHometuitionKanpur from './HomeTutorsCities/Kanpur/IITJEEHometuitionKanpur'
import CBSEHomeTuitionKanpur from './HomeTutorsCities/Kanpur/CBSEHomeTuitionKanpur'
import MathematicsTuitionKanpur from './HomeTutorsCities/Kanpur/MathematicsTuitionKanpur'
import HomeTuitionLucknow from './HomeTutorsCities/Lucknow/HomeTuitionLucknow'
import IITJEEHomeTuitionnLucknow from './HomeTutorsCities/Lucknow/IITJEEHomeTuitionnLucknow'
import CBSETuitionLucknow from './HomeTutorsCities/Lucknow/CBSETuitionLucknow'
import MathematicsHomeTuitionLucknow from './HomeTutorsCities/Lucknow/MathematicsHomeTuitionLucknow'
import HomeTuitionSurat from './HomeTutorsCities/Surat/HomeTuitionSurat'
import IITJEEHomeTuitionSurat from './HomeTutorsCities/Surat/IITJEEHomeTuitionSurat'
import CBSEHomeTuitionSurat from './HomeTutorsCities/Surat/CBSEHomeTuitionSurat'
import MathematicsHomeTuitionSurat from './HomeTutorsCities/Surat/MathematicsHomeTuitionSurat'
import HomeTuitionGhaziabad from './HomeTutorsCities/Ghaziabad/HomeTuitionGhaziabad'
import IITJEEHomeTuitionGhaziabad from './HomeTutorsCities/Ghaziabad/IITJEEHomeTuitionGhaziabad'
import CBSEHomeTuitionGhaziabad from './HomeTutorsCities/Ghaziabad/CBSEHomeTuitionGhaziabad'
import MathematicsHomeTuitionGhaziabad from './HomeTutorsCities/Ghaziabad/MathematicsHomeTuitionGhaziabad'
import HomeTuitionJhansi from './HomeTutorsCities/Jhansi/HomeTuitionJhansi'
import IITJEEHomeTuitionJhansi from './HomeTutorsCities/Jhansi/IITJEEHomeTuitionJhansi'
import CBSEHomeTuitionJhansi from './HomeTutorsCities/Jhansi/CBSEHomeTuitionJhansi'
import MathematicsHomeTuitionJhansi from './HomeTutorsCities/Jhansi/MathematicsHomeTuitionJhansi'
import HomeTuitionAgra from './HomeTutorsCities/Agra/HomeTuitionAgra'
import IITJEEHomeTuitionAgra from './HomeTutorsCities/Agra/IITJEEHomeTuitionAgra'
import CBSEHomeTuitionAgra from './HomeTutorsCities/Agra/CBSEHomeTuitionAgra'
import MathematicsHomeTuitionAgra from './HomeTutorsCities/Agra/MathematicsHomeTuitionAgra'
import HomeTuitionBareilly from './HomeTutorsCities/Bareilly/HomeTuitionBareilly'
import IITJEEHomeTuitionBareilly from './HomeTutorsCities/Bareilly/IITJEEHomeTuitionBareilly'
import CBSEHomeTuitionBareilly from './HomeTutorsCities/Bareilly/CBSEHomeTuitionBareilly'
import MathematicsHomeTuitionBareilly from './HomeTutorsCities/Bareilly/MathematicsHomeTuitionBareilly'
import HomeTuitionBhopal from './HomeTutorsCities/Bhopal/HomeTuitionBhopal'
import IITJEEHomeTuitionBhopal from './HomeTutorsCities/Bhopal/IITJEEHomeTuitionBhopal'
import CBSEHomeTuitionBhopal from './HomeTutorsCities/Bhopal/CBSEHomeTuitionBhopal'
import MathematicsHomeTuitionBhopal from './HomeTutorsCities/Bhopal/MathematicsHomeTuitionBhopal'
import HomeTuitionIndore from './HomeTutorsCities/Indore/HomeTuitionIndore'
import IITJEEHomeTuitionIndore from './HomeTutorsCities/Indore/IITJEEHomeTuitionIndore'
import CBSEHomeTuitionIndore from './HomeTutorsCities/Indore/CBSEHomeTuitionIndore'
import MathematicsHomeTuitionIndore from './HomeTutorsCities/Indore/MathematicsHomeTuitionIndore'
import HomeTutorKolkata from './HomeTutorsCities/Kolkata/HomeTutorKolkata'
import IITJEEHomeTuitionKolkata from './HomeTutorsCities/Kolkata/IITJEEHomeTuitionKolkata'
import CBSEHomeTuitionKolkata from './HomeTutorsCities/Kolkata/CBSEHomeTuitionKolkata'
import MathematicsHomeTutionKolkata from './HomeTutorsCities/Kolkata/MathematicsHomeTutionKolkata'
import HomeTuitionGoa from './HomeTutorsCities/Goa/HomeTuitionGoa'
import IITJEEHomeTuitionGoa from './HomeTutorsCities/Goa/IITJEEHomeTuitionGoa'
import CBSEHomeTuitionGoa from './HomeTutorsCities/Goa/CBSEHomeTuitionGoa'
import MathematicsHomeTuitionGoa from './HomeTutorsCities/Goa/MathematicsHomeTuitionGoa'
import HomeTuitionDehradun from './HomeTutorsCities/Dehradun/HomeTuitionDehradun'
import IITJEEHomeTuitionDehradun from './HomeTutorsCities/Dehradun/IITJEEHomeTuitionDehradun'
import MathematicsHomeTuitionDehradun from './HomeTutorsCities/Dehradun/MathematicsHomeTuitionDehradun'
import CBSEHomeTuitionDehradun from './HomeTutorsCities/Dehradun/CBSEHomeTuitionDehradun'
import HomeTuitionRanchi from './HomeTutorsCities/Ranchi/HomeTuitionRanchi'
import IITJEEHomeTuitionRanchi from './HomeTutorsCities/Ranchi/IITJEEHomeTuitionRanchi'
import CBSEHomeTuitionRanchi from './HomeTutorsCities/Ranchi/CBSEHomeTuitionRanchi'
import MathematicsHomeTuitionRanchi from './HomeTutorsCities/Ranchi/MathematicsHomeTuitionRanchi'
import HomeTuitionJalandhar from './HomeTutorsCities/Jalandhar/HomeTuitionJalandhar'
import IITJEEHomeTuitionJalandhar from './HomeTutorsCities/Jalandhar/IITJEEHomeTuitionJalandhar'
import CBSEHomeTuitionJalandhar from './HomeTutorsCities/Jalandhar/CBSEHomeTuitionJalandhar'
import MathematicsHomeTuitionJalandhar from './HomeTutorsCities/Jalandhar/MathematicsHomeTuitionJalandhar'
import HomeTuitionPanchkula from './HomeTutorsCities/Panchkula/HomeTuitionPanchkula'
import IITJEEHomeTuitionPanchkula from './HomeTutorsCities/Panchkula/IITJEEHomeTuitionPanchkula'
import CBSEHomeTuitionPanchkula from './HomeTutorsCities/Panchkula/CBSEHomeTuitionPanchkula'
import MathematicsHomeTuitionPanchkula from './HomeTutorsCities/Panchkula/MathematicsHomeTuitionPanchkula'


const PrivateRouting = () => {
  const PrivacyPolicyRedirect = () => {
    React.useEffect(() => {
      window.location.href = '/privacypolicy.html';
    }, []);
    return null;
  };


  return (
    <>

      <BrowserRouter>
        <Routes>
          <Route path='/' exact element={<Landing url="https://kanhahometutions.com/" />}></Route>

          <Route path="/:slug" element={<SitemapSlug />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path='/post-teacher-job' element={<Institute/>}/>
          <Route path='/contact-us' element={<ContactUs/>}/>
          <Route path='/for-teacher' element={<ForTeacher/>}/>
          <Route path='/for-student' element={<ForStudent/>}/>
          <Route path='/navbar' element={<NavBar/>}/>
          <Route path='/study-material' element={<StudyMaterial/>}/>
          <Route path='/study-material-chapter' element={<Chapter/>}/>
          <Route path='/teacher-job' element={<TeacherJobs/>}/>
          <Route path='/expert-faculty' element={<TeacherSec/>}/>
          <Route path='/about-us' element={<AboutUs/>}/>

          <Route path='/home-tutors-in-jaipur' element={<HometutorsJaipur/>}/>
          <Route path='/iit-jee-home-tutor-in-jaipur' element={<IIT_JEEHometutorjaipur/>}/>
          <Route path='/cbse-tutors-in-jaipur' element={<CBSEtutorsJaipur/>}/>
          <Route path='/mathematics-tutors-in-jaipur' element={<MathematicstutorsJaipur/>}/>

          <Route path='/home-tutors-in-delhi' element={<HometutorsDelhi/>}/>
          <Route path='/iit-jee-home-tutor-in-delhi' element={<IIT_JEEHometutorDelhi/>}/>
          <Route path='/cbse-tutors-in-delhi' element={<CBSEtutorsDelhi/>}/>
          <Route path='/mathematics-tutors-in-delhi' element={<MathematicstutorsDelhi/>}/>

          <Route path='/home-tutors-in-gurgaon' element={<HometutorsGurugram/>}/>
          <Route path='/iit-jee-home-tutor-in-gurgaon' element={<IIT_JEEHometutorGurugram/>}/>
          <Route path='/cbse-tutors-in-gurgaon' element={<CBSEtutorsGurugram/>}/>
          <Route path='/mathematics-tutors-in-gurgaon' element={<MathematicstutorsGurugram/>}/>

          <Route path='/home-tuition-in-bangalore' element={<HometuitionsBangalore/>}/>
          <Route path='/iit-jee-home-tuition-in-bangalore' element={<IITjeeTutionsBangalore/>}/>
          <Route path='/cbse-home-tutors-in-bangalore' element={<CBSEHomeTutorsBangalore/>}/>
          <Route path='/mathematics-tutors-in-bangalore' element={<MathematicsTutorsBangalore/>}/>

          <Route path='/home-tuition-in-mumbai' element={<HomeTuitionMumbai/>}/>
          <Route path='/iit-jee-tuitions-in-mumbai' element={<IitJeetuitionsMumbai/>}/>
          <Route path='/cbse-home-tutors-in-mumbai' element={<CbseHomeTutorsMumbai/>}/>
          <Route path='/mathematics-tuition-in-mumbai' element={<MathematicsTuitionMumbai/>}/>

          <Route path='/home-tuition-in-ahmedabad' element={<HometuitionAhmedabad/>}/>
          <Route path='/iit-jee-home-tuition-in-ahmedabad' element={<IITJEETuitionAhmedabad/>}/>
          <Route path='/cbse-home-tuition-in-ahmedabad' element={<CBSETuitioninAhmedabad/>}/>
          <Route path='/mathematics-home-tutor-in-ahmedabad' element={<MathematicsTuitionAhmedabad/>}/>

          <Route path='/home-tuition-in-pune' element={<HometuitioninPune/>}/>
          <Route path='/iit-jee-home-tuition-in-pune' element={<IITJEEtutionsPune/>}/>
          <Route path='/cbse-home-tutors-in-pune' element={<CBSEHomeTutorsPune/>}/>
          <Route path='/mathematics-home-tutors-in-pune' element={<MathematicsTutorsPune/>}/>

          <Route path='/home-tuitions-in-hyderabad' element={<HometuitionsHyderabad/>}/>
          <Route path='/iit-jee-home-tuition-in-hyderabad' element={<IITJEEtutionsHyderabad/>}/>
          <Route path='/cbse-home-tutors-in-hyderabad' element={<CBSEHomeTutorsHyderabad/>}/>
          <Route path='/mathematics-home-tutors-in-hyderabad' element={<MathematicsTutorsHyderabad/>}/>

          <Route path='/home-tuition-in-nagpur' element={<HomeTuitionNagpur/>}/>
          <Route path='/iit-jee-home-tuition-in-nagpur' element={<IITJEEHomeTuitionNagpur/>}/>
          <Route path='/cbse-home-tuition-in-nagpur' element={<CBSEHomeTuitioninNagpur/>}/>
          <Route path='/mathematics-home-tuition-in-nagpur' element={<MathematicsHomeTuitionNagpur/>}/>

          <Route path='/home-tuition-in-kanpur' element={<HomeTuitionKanpur/>}/>
          <Route path='/iit-jee-home-tuition-in-kanpur' element={<IITJEEHometuitionKanpur/>}/>
          <Route path='/cbse-home-tuition-in-kanpur' element={<CBSEHomeTuitionKanpur/>}/>
          <Route path='/mathematics-home-tuition-in-kanpur' element={<MathematicsTuitionKanpur/>}/>

          <Route path='/home-tuition-in-lucknow' element={<HomeTuitionLucknow/>}/>
          <Route path='/iit-jee-home-tuition-in-lucknow' element={<IITJEEHomeTuitionnLucknow/>}/>
          <Route path='/cbse-home-tuition-in-lucknow' element={<CBSETuitionLucknow/>}/>
          <Route path='/mathematics-home-tuition-in-lucknow' element={<MathematicsHomeTuitionLucknow/>}/>

          <Route path='/home-tuition-in-surat' element={<HomeTuitionSurat/>}/>
          <Route path='/iit-jee-home-tuition-in-surat' element={<IITJEEHomeTuitionSurat/>}/>
          <Route path='/cbse-home-tuition-in-surat' element={<CBSEHomeTuitionSurat/>}/>
          <Route path='/mathematics-home-tuition-in-surat' element={<MathematicsHomeTuitionSurat/>}/>

          <Route path='/home-tuition-in-ghaziabad' element={<HomeTuitionGhaziabad/>}/>
          <Route path='/iit-jee-home-tuition-in-ghaziabad' element={<IITJEEHomeTuitionGhaziabad/>}/>
          <Route path='/cbse-home-tuition-in-ghaziabad' element={<CBSEHomeTuitionGhaziabad/>}/>
          <Route path='/mathematics-home-tuition-in-ghaziabad' element={<MathematicsHomeTuitionGhaziabad/>}/>

          <Route path='/home-tuition-in-jhansi' element={<HomeTuitionJhansi/>}/>
          <Route path='/iit-jee-home-tuition-in-jhansi' element={<IITJEEHomeTuitionJhansi/>}/>
          <Route path='/cbse-home-tuition-in-jhansi' element={<CBSEHomeTuitionJhansi/>}/>
          <Route path='/mathematics-home-tuition-in-jhansi' element={<MathematicsHomeTuitionJhansi/>}/>

          <Route path='/home-tuition-in-agra' element={<HomeTuitionAgra/>}/>
          <Route path='/iit-jee-home-tuition-in-agra' element={<IITJEEHomeTuitionAgra/>}/>
          <Route path='/cbse-home-tuition-in-agra' element={<CBSEHomeTuitionAgra/>}/>
          <Route path='/mathematics-home-tuition-in-agra' element={<MathematicsHomeTuitionAgra/>}/>

          <Route path='/home-tuition-in-bareilly' element={<HomeTuitionBareilly/>}/>
          <Route path='/iit-jee-home-tuition-in-bareilly' element={<IITJEEHomeTuitionBareilly/>}/>
          <Route path='/cbse-home-tuition-in-bareilly' element={<CBSEHomeTuitionBareilly/>}/>
          <Route path='/mathematics-home-tuition-in-bareilly' element={<MathematicsHomeTuitionBareilly/>}/>

          <Route path='/home-tuition-in-bhopal' element={<HomeTuitionBhopal/>}/>
          <Route path='/iit-jee-home-tuition-in-bhopal' element={<IITJEEHomeTuitionBhopal/>}/>
          <Route path='/cbse-home-tuition-in-bhopal' element={<CBSEHomeTuitionBhopal/>}/>
          <Route path='/mathematics-home-Tuition-in-bhopal' element={<MathematicsHomeTuitionBhopal/>}/>

          <Route path='/home-tuition-in-indore' element={<HomeTuitionIndore/>}/>
          <Route path='/iit-jee-home-tuition-in-indore' element={<IITJEEHomeTuitionIndore/>}/>
          <Route path='/cbse-home-tuition-in-indore' element={<CBSEHomeTuitionIndore/>}/>
          <Route path='/mathematics-home-tuition-in-indore' element={<MathematicsHomeTuitionIndore/>}/>

          <Route path='/home-tutor-in-kolkata' element={<HomeTutorKolkata/>}/>
          <Route path='/iit-jee-home-tuition-in-kolkata' element={<IITJEEHomeTuitionKolkata/>}/>
          <Route path='/cbse-home-tuition-in-kolkata' element={<CBSEHomeTuitionKolkata/>}/>
          <Route path='/mathematics-home-tution-in-kolkata' element={<MathematicsHomeTutionKolkata/>}/>

          <Route path='/home-tuition-in-goa' element={<HomeTuitionGoa/>}/>
          <Route path='/iit-jee-home-tuition-in-goa' element={<IITJEEHomeTuitionGoa/>}/>
          <Route path='/cbse-home-tuition-in-goa' element={<CBSEHomeTuitionGoa/>}/>
          <Route path='/mathematics-home-tuition-in-goa' element={<MathematicsHomeTuitionGoa/>}/>

          <Route path='/home-tuition-in-dehradun' element={<HomeTuitionDehradun/>}/>
          <Route path='/iit-jee-home-tuition-in-dehradun' element={<IITJEEHomeTuitionDehradun/>}/>
          <Route path='/cbse-home-tuition-in-dehradun' element={<CBSEHomeTuitionDehradun/>}/>
          <Route path='/mathematics-home-tuition-in-dehradun' element={<MathematicsHomeTuitionDehradun/>}/>

           <Route path='/home-tuition-in-ranchi' element={<HomeTuitionRanchi/>}/>
          <Route path='/iit-jee-home-tuition-in-ranchi' element={<IITJEEHomeTuitionRanchi/>}/>
          <Route path='/cbse-home-tuition-in-ranchi' element={<CBSEHomeTuitionRanchi/>}/>
          <Route path='/mathematics-home-tuition-in-ranchi' element={<MathematicsHomeTuitionRanchi/>}/>

           <Route path='/home-tuition-in-jalandhar' element={<HomeTuitionJalandhar/>}/>
          <Route path='/iit-jee-home-tuition-in-jalandhar' element={<IITJEEHomeTuitionJalandhar/>}/>
          <Route path='/cbse-home-tuition-in-jalandhar' element={<CBSEHomeTuitionJalandhar/>}/>
          <Route path='/mathematics-home-Tuition-in-jalandhar' element={<MathematicsHomeTuitionJalandhar/>}/>

          <Route path='/home-tuition-in-panchkula' element={<HomeTuitionPanchkula/>}/>
          <Route path='/iit-jee-home-tuition-in-panchkula' element={<IITJEEHomeTuitionPanchkula/>}/>
          <Route path='/cbse-home-tuition-in-panchkula' element={<CBSEHomeTuitionPanchkula/>}/>
          <Route path='/mathematics-home-tuition-in-panchkula' element={<MathematicsHomeTuitionPanchkula/>}/>

          <Route path='/online-coaching-in-kathmandu' element={<KathmanduPage/>}></Route>
          <Route path='/online-tuition-classes' element={<OnlineCoaching/>}></Route>
          <Route path='/student-signin' exact element={<Signup />}></Route>
          <Route path='/admin-login' exact element={<AdminLogin />}></Route>

          <Route path='/signup-teacher' exact element={<SignupTeacher />}></Route>
          <Route path='/signin-teacher' exact element={<LoginTeacher />}></Route>

          <Route path='/tutor-verify-otp' exact element={<VerifyOtp />}></Route>
          <Route path="/form-teacher" element={<Protected Component={FormTeacher} />} />

          <Route path='/signup-otp' exact element={<SignupOtp />}></Route>
          <Route path="/successfull" element={<Protected Component={Successfull} />} />

          <Route path='/login' exact element={<Login />}></Route>
          <Route path='/loginOtp' exact element={<LoginOtp />}></Route>
          <Route path='/privacy-policy' exact element={<PrivacyPolicyRedirect />}></Route>
          <Route path='/terms-conditions' exact element={<TermsAndConditions />}></Route>
          <Route path='/refund-policy' exact element={<RefundPolicy />}></Route>
          <Route path='/blogs' exact element={<Blogs />}></Route>
          <Route path='/blog/:slug' exact element={<BlogNextPage />}></Route>
          <Route path='/privacy-policy-mobile' exact element={<PrivacyPolicyMobile />}></Route>
          <Route path='/refund-policy-mobile' exact element={<RefundPolicyMobile />}></Route>
          <Route path='/terms-conditions-mobile' exact element={<TermsAndConditionsMobile />}></Route>

          <Route path='/update-number' exact element={<UpdateNumberOtp />}></Route>
          <Route path='/deleteStudentAccount' element={<AccountDeleteStudent />}></Route>
          <Route path='/deleteTutorAccount' element={<AccountDeleteTeacher />}></Route>

          {/*  */}
          <Route path="/subject" element={<Protected Component={Subject} />} />
          <Route path="/location" element={<Protected Component={Location} />} />
          <Route path="/education" element={<Protected Component={Education} />} />
          <Route path="/subsubjects" element={<Protected Component={SubSubjects} />} />
          <Route path="/fee" element={<Protected Component={Fee} />} />
          <Route path="/classes" element={<Protected Component={Classes} />} />
          <Route path="/days" element={<Protected Component={Days} />} />
          <Route path="/start" element={<Protected Component={Start} />} />
          <Route path="/online" element={<Protected Component={Online} />} />
          <Route path="/gender" element={<Protected Component={Gender} />} />

          <Route path="/dashboard" element={<Layout />}>
            {/* admin route start here */}
            <Route path="/dashboard/admin" element={<Protected Component={AdminDashboard} />} />
            <Route path="/dashboard/createPost" element={<Protected Component={AdminCreatePost} />} />
            <Route path="/dashboard/studentList" element={<Protected Component={StudentList} />} />
            <Route path="/dashboard/teacherList" element={<Protected Component={TeacherList} />} />
            <Route path="/dashboard/manageCredit" element={<Protected Component={ManageCredit} />} />
            <Route path="/dashboard/manageEnquiry" element={<Protected Component={ManageEnquiry} />} />
            <Route path="/dashboard/manageFeedback" element={<Protected Component={ManageFeedback} />} />
            <Route path="/dashboard/board&courses" element={<Protected Component={BoardAndClasses} />} />
            <Route path="/dashboard/board/classes" element={<Protected Component={ClassesStudymaterial} />} />
            <Route path="/dashboard/board/classes/subjects" element={<Protected Component={SubjectsStudyMaterial} />} />
            <Route path="/dashboard/board/classes/subjects/notes" element={<Protected Component={Notes} />} />
            <Route path="/dashboard/blogs/all-post" element={<Protected Component={Allpost} />} />    
            <Route path="/dashboard/blogs/add-post" element={<Protected Component={AddPost} />} />
            <Route path="/dashboard/expert-faculty/add-teacher" element={<Protected Component={AddTeacher} />} />
            <Route path="/dashboard/expert-faculty/all-teacher" element={<Protected Component={AllTeachers} />} />

            {/* admin route end here */}
            <Route path="/dashboard/home" element={<Protected Component={Home} />} />
            <Route path="/dashboard/homeclass/:itemId" element={<HomeClass />} />
            <Route path="/dashboard/teacherreviews/:teacherId" element={<TeacherReviews />} />
            <Route path="/dashboard/write-review" element={<CreateReview />} />
            <Route path="/dashboard/enquirydetails" element={<EnquiryDetails />} />
            <Route path="/dashboard/learningneeds" element={<Subject />} />
            <Route path="/dashboard/location" element={<Location />} />
            <Route path="/dashboard/education" element={<Education />} />
            <Route path="/dashboard/subsubjects" element={<SubSubjects />} />
            <Route path="/dashboard/classes" element={<Classes />} />
            <Route path='/dashboard/fee' exact element={<Fee />}></Route>
            <Route path='/dashboard/days' exact element={<Days />}></Route>
            <Route path='/dashboard/start' exact element={<Start />}></Route>
            <Route path='/dashboard/online' exact element={<Online />}></Route>
            <Route path='/dashboard/gender' exact element={<Gender />}></Route>
            <Route path="/dashboard/notifications" element={<Notifications />} />
            <Route path="/dashboard/help-support" element={<HelpAndSupport />} />
            <Route path="/dashboard/feedback" element={<Feedback />} />
            <Route path="/dashboard/profile" element={<AccountProfile />} />
            <Route path="/dashboard/settings" element={<AccountSettings />} />

            {/* teacher route start below */}
            <Route path="/dashboard/dashboard-home" element={<DashboardHome />} />
            <Route path="/dashboard/dashboard-home-enquiry/:itemId" element={<DashboardHomeEnquiryClick />} />
            <Route path="/dashboard/profileinformation" element={<Protected Component={ProfileInformation} />} />

            <Route path="/dashboard/profileedit" element={<Protected Component={ProfileEdit} />} />
            <Route path="/dashboard/profiletagline" element={<ProfileTagline />} />
            <Route path="/dashboard/phonenumber" element={<Protected Component={PhoneNumber} />} />
            <Route path="/dashboard/address" element={<Protected Component={Address} />} />
            <Route path="/dashboard/qualification" element={<Protected Component={QualificationExp} />} />
            <Route path="/dashboard/profileeducation" element={<Protected Component={ProfileEducation} />} />
            <Route path="/dashboard/language" element={<Protected Component={Language} />} />
            <Route path="/dashboard/summary" element={<Protected Component={Summary} />} />
            <Route path="/dashboard/schoollocation" element={<SchoolLocation />} />
            <Route path="/dashboard/tutoring" element={<Protected Component={Tutoring} />} />
            <Route path="/dashboard/classconducted" element={<Protected Component={ClassConducted} />} />
            <Route path="/dashboard/add-class" element={<Protected Component={AddClass} />} />
            <Route path="/dashboard/pricingclass" element={<PricingClass />} />
            <Route path="/dashboard/classcourse" element={<Protected Component={ClassCourse} />} />
            <Route path="/dashboard/reviews" element={<Protected Component={Reviews} />} />
            <Route path="/dashboard/tutorprofile" element={<Protected Component={TutorProfile} />} />
            <Route path="/dashboard/closeaccount" element={<Protected Component={CloseAccount} />} />
            <Route path="/dashboard/support" element={<Protected Component={HelpSupport} />} />
            <Route path="/dashboard/notification" element={<Protected Component={NotificationTeacher} />} />
            <Route path="/dashboard/subscriptionplan" element={<Protected Component={SubscriptionPlan} />} />
            <Route path="/dashboard/subscriptionhistory" element={<Protected Component={SubscriptionHistory} />} />
            <Route path="/dashboard/credithistory" element={<Protected Component={CreditHistory} />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default PrivateRouting
